var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 455.49 450.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.81,450.26a58.91,58.91,0,0,1-41.62-17.07l-.08-.08a59.48,59.48,0,0,1,0-83.21L247,124.87A105.21,105.21,0,0,1,380.49,4.46,10,10,0,0,1,384.7,21L355.08,50.8,340.7,65.18l5.18,19.65,5.28,19.61L390.47,115,405,100.65l29.59-29.6a10,10,0,0,1,16.61,4.22A105.35,105.35,0,0,1,330.58,208.73L105.46,433.17A59,59,0,0,1,63.81,450.26ZM36.26,419.07a39.29,39.29,0,0,0,55.14,0l229-228.25a10,10,0,0,1,9.42-2.62A85.4,85.4,0,0,0,435.29,98.49L419,114.77l-18.57,18.44a10,10,0,0,1-9.61,2.55l-50.39-13.57a10,10,0,0,1-7-7L326.62,90,320,64.72a10,10,0,0,1,2.59-9.59L341,36.72l16.41-16.48a85.31,85.31,0,0,0-89.8,105.44,10,10,0,0,1-2.63,9.44L36.26,363.94A39.46,39.46,0,0,0,36.26,419.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.84,450.26a59,59,0,0,1-41.63-17.07l-77.13-77.14a10,10,0,0,1,0-14.09l68.3-68.3a10,10,0,0,1,15-1.05l77.11,77.25a59.49,59.49,0,0,1,0,83.25l-.08.08A58.92,58.92,0,0,1,375.84,450.26ZM278.22,349l70.06,70.05a39,39,0,1,0,55.07-55.16l-70-70.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.87,208.92a10,10,0,0,1-7.06-2.93L80.57,110.61A10,10,0,0,1,94.68,96.53l95.24,95.38a10,10,0,0,1-7,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.87,324.78a9.94,9.94,0,0,1-7-2.91l-44.29-44.16a10,10,0,1,1,14.07-14.11l44.3,44.16a10,10,0,0,1-7,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.16,132.36a9.5,9.5,0,0,1-1.19-.07,10,10,0,0,1-7.32-4.71L1.46,56.71A10,10,0,0,1,2.92,44.47L33.37,14a10,10,0,0,1,12.24-1.47l70.87,43.19a10,10,0,0,1,1.87,15.56L60.2,129.44A10,10,0,0,1,53.16,132.36ZM22.56,53l32.51,53.36L95.29,66.17,41.93,33.66Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.73a411c0bfd31d98cdf1cf05cc9729ce.svg";
export { ForwardRef as ReactComponent };